export default "__VITE_ASSET__96215fce__"